import { useState, useEffect } from "react";

const useScreenSize = () => {
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return screenSize;
};

export const useIsMobileScreen = () => {
    const screen = useScreenSize();
    const [isMobile, setIsMobile] = useState(screen.width < 900);

    useEffect(() => {
        setIsMobile(screen.width < 900);
    }, [screen]);

    return isMobile;
};

export default useScreenSize;
